export const PHONE_MAX_WIDTH = 600;
export const TABLET_MAX_WIDTH = 1030;
export const DESKTOP_MAX_WIDTH = 1440;
